module.exports = __webpack_public_path__ + "static/img/team-cd-02.90d51c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/estate/team/team-cd-02.jpg
// module id = t8zZ
// module chunks = 1